export const convertCmToInches = (cm: number): string => {
    return (cm / 2.54).toFixed(2);
  };
  